import { useState } from "react";
import { NavLink } from "react-router-dom";
import "./sidebar.css";
import {
  Logo,
  DashboardIcon,
  DashboardIconActive,
  AssignedUserIcon,
  AssignedUserIconActive,
  ServiceRequestIcon,
  ServiceRequestIconActive,
  CommunicatiomnIcon,
  CommunicationIconActive,
  VendorIcon,
  VendorIconActive,
  ProfileIcon,
  ProfileIconActive,
} from "../../assets/ExportImageIcon";

const ManagerSidebar = ({ collapsed }) => {
  const [isHover, setIsHover] = useState(false);

  const isExpanded = !collapsed || isHover;

  return (
    <div
      className={`sidebar ${collapsed ? "collapsed" : ""} ${
        isHover ? "hover-open" : ""
      }`}
      onMouseEnter={() => collapsed && setIsHover(true)}
      onMouseLeave={() => {
        if (collapsed) setIsHover(false);
      }}
    >
      {/* LOGO */}
      <div className="logo">
        <img src={Logo} alt="Logo" className="logo-img" />
      </div>

      <ul className="menu">
        {/* DASHBOARD */}
        {isExpanded && <li className="menu-title">DASHBOARD</li>}

        <li className="menu-item">
          <NavLink
            to="/manager-dashboard"
            className={({ isActive }) =>
              isActive ? "menu-link active" : "menu-link"
            }
          >
            {({ isActive }) => (
              <>
                <img src={isActive ? DashboardIconActive : DashboardIcon} className="menu-icon-img" alt="" />
                {isExpanded && <span className="menu-text">Dashboard</span>}
              </>
            )}
          </NavLink>
        </li>

        {/* MANAGER PANEL */}
        {isExpanded && <li className="menu-title">MANAGER PANEL</li>}

        <li className="menu-item">
          <NavLink to="/assigned-users" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
            {({ isActive }) => (
              <>
                <img src={isActive ? AssignedUserIconActive : AssignedUserIcon} className="menu-icon-img" alt="" />
                {isExpanded && <span className="menu-text">Assigned Users</span>}
              </>
            )}
          </NavLink>
        </li>

        <li className="menu-item">
          <NavLink to="/service-manager" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
            {({ isActive }) => (
              <>
                <img src={isActive ? ServiceRequestIconActive : ServiceRequestIcon} className="menu-icon-img" alt="" />
                {isExpanded && <span className="menu-text">Service Request</span>}
              </>
            )}
          </NavLink>
        </li>

        <li className="menu-item">
          <NavLink to="/communication" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
            {({ isActive }) => (
              <>
                <img src={isActive ? CommunicationIconActive : CommunicatiomnIcon} className="menu-icon-img" alt="" />
                {isExpanded && <span className="menu-text">Communication</span>}
              </>
            )}
          </NavLink>
        </li>

        <li className="menu-item">
          <NavLink to="/manager-vendors" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
            {({ isActive }) => (
              <>
                <img src={isActive ? VendorIconActive : VendorIcon} className="menu-icon-img" alt="" />
                {isExpanded && <span className="menu-text">Vendors</span>}
              </>
            )}
          </NavLink>
        </li>

        {/* <li className="menu-item">
          <NavLink to="/manager-housing" className="menu-link">
            <img src={transactionIcon} className="menu-icon-img" alt="" />
            {isExpanded && <span className="menu-text">Housing Listings</span>}
          </NavLink>
        </li> */}

        <li className="menu-item">
          <NavLink to="/manager-profile" className={({ isActive }) => isActive ? "menu-link active" : "menu-link"}>
            {({ isActive }) => (
              <>
                <img src={isActive ? ProfileIconActive : ProfileIcon} className="menu-icon-img" alt="" />
                {isExpanded && <span className="menu-text">Profile</span>}
              </>
            )}
          </NavLink>
        </li>
      </ul>

      {/* FOOTER
      {isExpanded && (
        <div className="sidebar-footer">
          <h6>Manager User</h6>
          <p>Program Manager</p>
        </div>
      )} */}
    </div>
  );
};

export default ManagerSidebar;